/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_WhatInputs */

const en_jobs_what = /** @type {(inputs: Jobs_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What it does`)
};

const he_jobs_what = /** @type {(inputs: Jobs_WhatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מה היא עושה`)
};

/**
* | output |
* | --- |
* | "What it does" |
*
* @param {Jobs_WhatInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const jobs_what = /** @type {((inputs?: Jobs_WhatInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_WhatInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_what(inputs)
	return he_jobs_what(inputs)
});